import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { firestore } from '../../config/firebase';
import ExportToPdf, { pdfIcon } from '../../config/ExportForPdf';
import ExportForExcel, { excelIcon } from '../../config/ExportForExcel';
import { fetchSalesList, deleteSale } from '../../store/actions/saleActions';
import { fetchInitialRate } from '../../store/actions/currencyActions';
import { updateProduct } from '../../store/actions/productActions';
import Swal from 'sweetalert2';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import SingleSale from './SingleSale/SingleSale';
import Spinner from '../UIComponents/Spinner';
import { FiSliders } from 'react-icons/fi';
import SaleWidget from './SaleWidget/';
import lang from './lang';
import './Sales.css';

class Sales extends Component {
    state = { display: 'none', category: '', totalItems: 0, data: [], currentData: [], pageSize: 10, filters: false }

    componentDidMount() {
        this.setState({
            totalItems: this.props.sales.length,
            currentData: this.props.sales.slice(0, this.state.pageSize),
            data: this.props.sales,
            display: 'none',
            filters: false,
        });

        // setTimeout(() => {
        //     firestore
        //         .collection('users')
        //         .doc(this.props.user.id)
        //         .collection('sales')
        //         .get()
        //         .then(doc => {
        //             // If current number of products is not equal on databae fetch products
        //             if (doc.size !== this.props.sales.length) {
        //                 // Get All sales
        //                 firestore
        //                     .collection('users')
        //                     .doc(this.props.user.id)
        //                     .collection('sales')
        //                     .orderBy("updatedAt", "desc")
        //                     .get().then(doc => {
        //                         const sales = doc.docs.map(item => ({ id: item.id, ...item.data() }));
        //                         this.props.fetchSalesList(sales);
        //                     }).catch(err => console.log(err))
        //             }
        //         })
        //         .catch(err => console.log(err));
        // }, 1000)

        firestore
            .collection('users')
            .doc(this.props.user.id)
            .collection('sales')
            .onSnapshot((doc) => {
                let sales = [];
                doc.forEach(item => sales.push({ ...item.data(), id: item.id }))
                this.props.fetchSalesList(sales);
            });

        if (!this.props.user.uzsAmount || this.props.user.uzsAmount === 0) {
            this.props.fetchInitialRate();
        }
    }


    componentDidUpdate(prevProps, prevState) {
        if (this.props.sales.length !== prevProps.sales.length) {
            this.forceUpdate();
            this.setState({
                totalItems: this.props.sales.length,
                currentData: this.props.sales.slice(0, this.state.pageSize),
                data: this.props.sales
            });
        }
    }

    removeSaleHandler = (id, productId, piecesForSold) => {
        // Alert Messages
        const { alert } = lang[this.props.user.lang].main;

        Swal.fire({
            title: alert.title,
            text: alert.text,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonText: alert.cancel,
            cancelButtonColor: '#d33',
            confirmButtonText: alert.yesBtn
        }).then((result) => {
            if (result.value) {
                // Add removing anomation CSS class 
                this[id + 'Ref'].classList.add('remove-me');

                // Remove element from database after 500ms when CSS anomation is over
                setTimeout(() => {
                    // Find the sales and delete
                    firestore.collection('users')
                        .doc(this.props.user.id)
                        .collection('sales')
                        .doc(id).delete();
                    // Remove the sale from sales' collection
                    this.props.deleteSale(id);

                    // Find the product and add current sales sold pieces number to product piece
                    const currentProduct = this.props.products.find(item => item.id === productId);
                    firestore.collection('users')
                        .doc(this.props.user.id)
                        .collection('products')
                        .doc(productId).update({ piece: currentProduct.piece + piecesForSold });
                    // update products after updating the products piece filed
                    this.props.updateProduct({ ...currentProduct, piece: currentProduct.piece + piecesForSold });
                }, 500)

            }
        })


    }
    sortByHandler = (e) => {
        e.preventDefault();
        const { value } = e.target;
        let data = [];

        if (value) {
            data = this.props.sales.filter(item => {
                return item.paymentStatus === value
            });
        } else {
            data = this.props.sales
        }

        this.setState({
            totalItems: data.length,
            currentData: data.slice(0, this.state.pageSize),
            data,
            category: value
        });
    }

    pageHandler = (page) => {
        const startPosition = this.state.pageSize * page - this.state.pageSize;
        const endPosition = this.state.pageSize * page <= this.state.totalItems ? (this.state.pageSize * page) : this.state.totalItems;
        let data = [];
        if (this.state.category) {
            data = this.props.sales.filter(item => {
                return item.paymentStatus === this.state.category
            }).slice(startPosition, endPosition)
        } else {
            data = this.props.sales.slice(startPosition, endPosition)
        }

        this.setState({
            currentData: data,
        })
    }

    pdfFileHandler = () => {
        const pdfData = this.state.data.map(item => {
            return {
                name: item.name,
                code: item.code,
                color: item.color,
                brand: item.brand,
                pieces: item.piecesForSale,
                price: item.totalValue,
                date: new Date(item.updatedAt).toLocaleString(),
                status: item.paymentStatus,
                payment: item.paymentType
            }
        })
        ExportToPdf({
            filename: 'sales-list',
            data: pdfData,
        })
    }


    // Sort Sale by Date
    monthSortHandler = (e) => {
        e.preventDefault();
        const startDate = new Date(this.startDate.state.value).getTime();
        const endDate = new Date(this.endDate.state.value + ' 23:59:59').getTime();

        const sales = this.props.sales.filter(sale => {
            return sale.updatedAt >= startDate && sale.updatedAt <= endDate;
        });

        this.setState({
            totalItems: sales.length,
            currentData: sales.slice(0, this.state.pageSize),
            data: sales,
        });
    }

    xlsFileHandler = () => {
        const xslData = this.state.data.map(item => {
            return {
                name: item.name,
                code: item.code,
                color: item.color,
                brand: item.brand,
                pieces: item.piecesForSale,
                price: item.totalValue,
                date: new Date(item.updatedAt).toLocaleString(),
                status: item.paymentStatus,
                payment: item.paymentType
            }
        })
        ExportForExcel({ fileName: 'sales-list', data: xslData })
    }

    redirectHandler = (id) => {
        this.props.history.push(`/sales/${id}`);
    }

    render() {
        console.log(this.state);

        const { payment, main: { newSale, title, context, action, table, filter } } = lang[this.props.user.lang || 'uz'];

        if (this.props.sales.length !== 0) {
            return (
                <div id="sale-list-page">
                    <Spinner display={this.state.display} />
                    <div className="text-right">
                        <Link to="/products" className="btn btn-success rounded-pill px-4">+ {newSale}</Link>
                    </div>
                    <div className="my-3 filter-btn">
                        <button
                            className={`btn btn-outline-secondary btn-sm rounded-pill px-4 ${this.state.filters ? 'active' : ''}`}
                            onClick={() => this.setState(prevState => ({ filters: !prevState.filters }))}
                        >
                            {filter.title}
                            <FiSliders className="ml-2" />
                        </button>
                    </div>
                    <div className="my-4 flex-wrap align-items-center" style={{ display: this.state.filters ? 'flex' : 'none' }}>
                        <button className="btn btn-sm btn-outline-success" onClick={(event) => this.sortByHandler(event)} value="">{filter.all}</button>
                        <button className="btn btn-sm btn-primary mx-2" onClick={(event) => this.sortByHandler(event)} value="paid">{filter.paid}</button>
                        <button className="btn btn-sm btn-warning" onClick={(event) => this.sortByHandler(event)} value="debt">{filter.debt}</button>
                        <button className="btn btn-sm btn-success mx-2" onClick={(event) => this.sortByHandler(event)} value="bonus">{filter.bonus}</button>
                        <button className="btn btn-sm btn-danger" onClick={(event) => this.sortByHandler(event)} value="canceled">{filter.canceled}</button>
                        <form onSubmit={(e) => this.monthSortHandler(e)} className="ml-auto d-flex align-items-center">
                            <DayPickerInput
                                ref={(ref) => this.startDate = ref}
                                dayPickerProps={{
                                    disabledDays: {
                                        after: new Date()
                                    }
                                }}
                                className="bordered"
                            />
                            <DayPickerInput
                                ref={(ref) => this.endDate = ref}
                                dayPickerProps={{
                                    disabledDays: {
                                        after: new Date()
                                    }
                                }}
                            />

                            <button className="btn btn-sm btn-primary">{filter.apply}</button>
                        </form>
                    </div>
                    <div className="download-icons">
                        <img src={pdfIcon} alt="Excel File" onClick={this.pdfFileHandler} />
                        <img src={excelIcon} alt="Pdf File" onClick={this.xlsFileHandler} />
                    </div>
                    <SaleWidget
                        language={this.props.user.lang}
                        data={this.state.data}
                        currency={this.props.user.currency}
                        rate={this.props.user.uzsAmount}
                    />
                    <table className="table table-striped table-hover table-responsive-md text-center table-bordered table-sm mt-3">
                        <thead className="thead-dark">
                            <tr>
                                <th scope="col">#</th>
                                {/* <th scope="col">{table.img}</th> */}
                                <th scope="col">{table.name}</th>
                                <th scope="col">{table.code}</th>
                                <th scope="col">{table.dimension}</th>
                                <th scope="col">{table.piece}</th>
                                {/* <th scope="col">m<sup>2</sup></th> */}
                                <th scope="col">{table.price}</th>
                                <th scope="col">{table.profit}</th>
                                <th scope="col">{table.brand}</th>
                                <th scope="col">{table.date}</th>
                                <th scope="col">{table.status}</th>
                                <th scope="col">{table.edit}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.currentData.map((item, i) => {
                                return (
                                    <SingleSale
                                        key={item.id + '-' + i}
                                        data={item}
                                        index={i}
                                        currency={this.props.user.currency}
                                        remove={this.removeSaleHandler}
                                        rate={item.currencyRate || this.props.user.uzsAmount}
                                        redirect={this.redirectHandler}
                                        payment={payment}
                                        elRef={ref => this[item.id + 'Ref'] = ref}
                                        isAdmin={this.props.auth.isAdmin}
                                    />
                                )
                            })}
                        </tbody>
                    </table>
                    <Pagination
                        showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                        total={this.state.totalItems}
                        pageSize={this.state.pageSize}
                        onChange={(page) => this.pageHandler(page)}
                        hideOnSinglePage={true}
                    />
                </div>
            );
        } else {
            return (
                <div className="jumbotron text-center">
                    <h1>{title}</h1>
                    <p className="lead mt-5 mb-3">{context}</p>
                    <Link to="/products" className="btn btn-success">{action} +</Link>
                </div>
            );
        }

    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        user: state.user,
        currency: state.currency,
        sales: state.sales.sales.sort((a, b) => b.createdAt - a.createdAt),
        products: state.products.products.sort((a, b) => b.updatedAt - a.updatedAt)
    }
}
const mapDispatchToProps = dispatch => {
    return {
        fetchSalesList: (data) => dispatch(fetchSalesList(data)),
        deleteSale: (id) => dispatch(deleteSale(id)),
        updateProduct: (product) => dispatch(updateProduct(product)),
        fetchInitialRate: () => dispatch(fetchInitialRate())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sales);